<template>
  <section id="intro">
    <div class="row clearfix">
      <article id="ceomessage" class="letter clearfix">
        <h1>Introduction:<br>2025 Live Performance Attendance and Revenue Report (digital report)</h1>

        <div class="sixcol">
          <p>Live Performance Australia (LPA) proudly presents the 2025 Attendance and Revenue Report. For more than two decades, the Report has served as the industry&rsquo;s leading source of information, offering insights into attendance, revenue and emerging trends across Australia&rsquo;s dynamic live performance landscape.</p>
          <p>In 2025, the live performance industry remained close to the record levels achieved in 2024. It generated $3.4 billion in ticket revenue and recorded 30.7 million attendances. Live performance in regional Australia accounted for 10.6% of total revenue and 11.6% of total attendance.</p>
          <p>These results suggest that audience demand for live events remains strong, especially major international acts and touring productions. However, beyond the headline results, year-over-year (y-o-y) growth was concentrated in a limited number of categories and jurisdictions. The costs associated with delivering live events continue to rise, and while the average ticket price has increased to offset these costs, the increase has not kept pace with inflation.</p>
          <p>Contemporary music concerts and festivals are the powerhouse of Australia&rsquo;s live performance industry, contributing almost two-thirds of revenue and almost 52% of ticketed attendances in 2025.</p>
          <p>While attendance and revenue for contemporary music categories remained strong, there were mixed results for theatrical categories. Circus and Physical Theatre and Opera recorded y-o-y increases, whereas Ballet and Dance, Children&rsquo;s and Family, Musical Theatre and Theatre all recorded y-o-y declines in both attendance and revenue.</p>
        </div>
        <div class="sixcol last">
          <p>Musical Theatre experienced the largest declines (16.8% decline in revenue and 16.6% decline in attendance), with its market share also declining over the past few years.</p>
          <p>There were also mixed results across jurisdictions. Western Australia, South Australia and the ACT experienced growth in both revenue and attendance, which was partly offset by modest declines in the three largest markets (NSW, Victoria and Queensland). Despite this, NSW and VIC remained Australia&rsquo;s leading live performance markets, together contributing 68.1% of revenue and 62.8% of attendance.</p>
          <p>These mixed outcomes highlight the evolving nature of audience behaviour and preferences, as well as challenging economic conditions overall.</p>
          <p>The publication of this Report is not possible without our almost 100 data providers; our research partner, EY; and our web designers, Paoli Smith. LPA is sincerely grateful for their contribution, partnership and professionalism, which have been instrumental to the successful delivery of this report.</p>
          <p>I encourage you to explore the Report and gain a deeper understanding of the trends and insights shaping our industry.</p>
          <p>
            <img src="@/assets/img/2024/eric-lassen-signature.png" alt="Eric Lassen's signature" width="98" height="65"><br>
            <strong>Eric Lassen</strong><br>
            Chief Executive Officer<br>
            Live Performance Australia<br><br>
            October 2026
          </p>
        </div>
        <div class="twelvecol last">
        </div>
      </article>

      <h1 id="download">Download the Report</h1>

      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/2025 Live Performance Australia_Attendance and Revenue Report (FINAL) (14 Oct 2026).pdf" class="button fullreport pdf" target="_blank">
          Live Performance Attendance and Revenue Report 2025 (PDF)
        </a>
      </div>

      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/AUS   Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Australia LPA Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>
    <div class="fullbg">
      <p class="caption">Photo: <em>The Pirates of Penzance - Jay Laga'aia and company</em>, Hayes Theatre Company, Photo Credit: John McRae</p>
      <div class="overlay"></div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped="scoped">
#intro .fullbg {
  background-image: url("~@/assets/img/2025/2-Introduction-The-Pirates-of-Penzance---Jay-Laga'aia---Photo-by-John-McRae.jpg");
}
</style>
